module.exports = __webpack_public_path__ + "img/car_shina2_21.05f22009.jpg";